module.exports = __webpack_public_path__ + "static/media/ic_opp_alert.d3576510.svg";